/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GiftcardDto } from './GiftcardDto';

export type GiftcardInfoDto = {
    error: GiftcardInfoDto.error;
    giftcardInfo: GiftcardDto;
};

export namespace GiftcardInfoDto {

    export enum error {
        BUYER_CANT_REDEEM = 'buyerCantRedeem',
        EXPIRED = 'expired',
        REDEEMED = 'redeemed',
        NOT_FOUND = 'not-found',
        ALREADY_ABO = 'already-abo',
        ALREADY_COURSE = 'already-course',
    }


}

